import urls from 'Source/urls';

export const activeDashboardUrls = [
  urls.dashboard.overview(),
  urls.dashboard.cloudSecurity(),
  urls.dashboard.data(),
  urls.dashboard.mitreMatrix(),
  urls.dashboard.customDashboard(':id'),
];

export const dashboardUrlsGroup = [
  urls.dashboard.home(),
  ...activeDashboardUrls,
  urls.dashboard.mitreMapping({}),
  '/overview/',
];

export const getDashboardUrlsGroup = (enableCustomDashboards: boolean) => {
  return enableCustomDashboards
    ? dashboardUrlsGroup
    : dashboardUrlsGroup.filter(url => url !== urls.dashboard.customDashboard(':id'));
};
